import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../Store';
import { BrowseCatalog } from '../../../../../Types';
import BrowseAllToggle from '../../../../../LearningCollectionSteps/BrowseAllToggle';

interface Props {
  store: LearningCollectionEditStore;
  browseCatalog: BrowseCatalog;
}

const Browse: React.FC<Props> = ({ browseCatalog, store }) => {
  switch (browseCatalog) {
    case 'displayed':
      const warnUser = () => store.browseAllCustomized;

      return (
        <div
          className={clsx(
            'rounded-md border border-solid border-gray-200 bg-white px-3 py-2',
            'flex items-center justify-between',
          )}
        >
          <div className="pr-4 text-sm font-semibold">
            <T kind="Participants can browse the full catalog" />
          </div>
          <BrowseAllToggle store={store} warnUser={warnUser} />
        </div>
      );
    case 'hidden':
      return <></>;
  }
};

export default observer(Browse);
